import { Outlet } from "react-router-dom";

const PushNotificationPageLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default PushNotificationPageLayout;